module.exports = __webpack_public_path__ + "static/media/krangle.db4d6009.m4a";